import { Dialog as BaseDialog } from '@base-ui/react/dialog';

import ArrowLeftIcon from '@/assets/svg/ui-elements/chevron-left.svg';
import { Spinner, Typography } from '@/design-system';

import { DetailState, StateCloseButton } from './styled';

export const PipelineDetailLoadingState = () => (
  <DetailState>
    <BaseDialog.Close
      render={
        <StateCloseButton
          aria-label="Close pipeline detail"
          size="xs"
          color="tertiary"
          variant="ghost"
        >
          <ArrowLeftIcon width={24} height={24} />
        </StateCloseButton>
      }
    />
    <Spinner />
    <Typography variant="body3">Loading card detail</Typography>
  </DetailState>
);

export const PipelineDetailErrorState = () => (
  <DetailState>
    <BaseDialog.Close
      render={
        <StateCloseButton
          aria-label="Close pipeline detail"
          size="xs"
          color="tertiary"
          variant="ghost"
        >
          <ArrowLeftIcon width={24} height={24} />
        </StateCloseButton>
      }
    />
    <Typography variant="h6">Detail unavailable</Typography>
    <Typography variant="body3">The card detail request failed.</Typography>
  </DetailState>
);
